import { render, staticRenderFns } from "./ModalAprovarDocumentosSuape.vue?vue&type=template&id=acb9310a&"
import script from "./ModalAprovarDocumentosSuape.vue?vue&type=script&lang=js&"
export * from "./ModalAprovarDocumentosSuape.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports